/**
 * DOM event handler for define blocks:
 * Swallow mouse events on button-group widgets so CM doesn't fold/place cursor.
 */

import { EditorView } from "@codemirror/view";

const swallowIfButtonGroup = (event: Event) =>
    event.target instanceof HTMLElement &&
    event.target.closest(".cm-magic-btn-group") !== null;

export const buttonGroupEventFilter = EditorView.domEventHandlers({
    mousedown: swallowIfButtonGroup,
    click: swallowIfButtonGroup,
    pointerdown: swallowIfButtonGroup,
});
